import { createApi } from '@reduxjs/toolkit/query/react';

import {
  MessageTemplatesEndpoints as Endpoints,
  type AttachFilesToMessageTemplateRequest,
  type AttachFilesToMessageTemplateResponse,
  type DeleteMessageTemplateRequest,
  type DeleteMessageTemplateResponse,
  type GetFilesMessageTemplateRequest,
  type GetFilesMessageTemplateResponse,
  type GetMessageTemplateRequest,
  type GetMessageTemplateResponse,
  type GetMessageTemplatesSearchResultRequest,
  type GetMessageTemplatesSearchResultResponse,
  type RemoveFilesFromMessageTemplateRequest,
  type RemoveFilesFromMessageTemplateResponse,
  type SearchForSystemMessageTemplatesRequest,
  type SearchForSystemMessageTemplatesResponse,
  type SearchMessageTemplatesRequest,
  type SearchMessageTemplatesResponse,
  type UpdateMessageTemplateRequest,
  type UpdateMessageTemplateResponse,
} from '@app/api/MessageTemplates/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { RESOURCES_MESSAGE_TEMPLATES } from '@app/constants';

export const messageTemplatesApi = createApi({
  reducerPath: 'messageTemplatesApi',
  baseQuery: createApiBaseQuery(RESOURCES_MESSAGE_TEMPLATES),
  endpoints: ({ mutation, query }) => ({
    [Endpoints.Update]: mutation<
      UpdateMessageTemplateResponse,
      UpdateMessageTemplateRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.Update,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.Delete]: mutation<
      DeleteMessageTemplateResponse,
      DeleteMessageTemplateRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.Delete,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.SearchForSystem]: query<
      SearchForSystemMessageTemplatesResponse,
      SearchForSystemMessageTemplatesRequest
    >({
      query: (params) => ({
        url: Endpoints.SearchForSystem,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.Search]: mutation<
      SearchMessageTemplatesResponse,
      SearchMessageTemplatesRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.Search,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.GetSearchResult]: query<
      GetMessageTemplatesSearchResultResponse,
      GetMessageTemplatesSearchResultRequest
    >({
      query: (params) => ({
        url: Endpoints.GetSearchResult,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.Get]: query<
      GetMessageTemplateResponse,
      GetMessageTemplateRequest
    >({
      query: (params) => ({
        url: Endpoints.Get,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.AttachFiles]: mutation<
      AttachFilesToMessageTemplateResponse,
      AttachFilesToMessageTemplateRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.AttachFiles,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.RemoveFiles]: mutation<
      RemoveFilesFromMessageTemplateResponse,
      RemoveFilesFromMessageTemplateRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.RemoveFiles,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.GetFiles]: mutation<
      GetFilesMessageTemplateResponse,
      GetFilesMessageTemplateRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.GetFiles,
        method: Methods.POST,
        params,
        data,
      }),
    }),
  }),
});

export const {
  useUpdateMutation,
  useDeleteMutation,
  useSearchForSystemQuery,
  useLazySearchForSystemQuery,
  useSearchMutation,
  useGetSearchResultQuery,
  useLazyGetSearchResultQuery,
  useGetQuery,
  useLazyGetQuery,
  useAttachFilesMutation,
  useRemoveFilesMutation,
  useGetFilesMutation,
} = messageTemplatesApi;
